import * as Types from './types';

export const setKeycloakLoaded = () => ({
  type: Types.KEYCLOAK_LOADED
});
